import { render, staticRenderFns } from "./nonTariffBarries.vue?vue&type=template&id=c9f94914&scoped=true&"
import script from "./nonTariffBarries.vue?vue&type=script&lang=js&"
export * from "./nonTariffBarries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f94914",
  null
  
)

export default component.exports